import React from 'react';
import { TimePicker } from "material-ui-pickers";

function MaterialTimePicker(props) {

  const { input: { value, onChange }, ...restProps } = props

  // console.warn('date picker: ', props)

  return (
    <TimePicker
       autoOk
       ampm={false}
       disableFuture
       value={value}
       onChange={date => onChange(date)}
       label="24h clock"
       {...restProps}
     />
   )
}

export default MaterialTimePicker
